import { application } from './application'
import { lazyController } from './lazy_controller'

import AutosubmitController from './autosubmit_controller'
import ClipboardController from './clipboard_controller'
import FileUploadController from './file_upload_controller'
import PlaylistController from './playlist_controller'

application.register('autosubmit', AutosubmitController)
application.register('clipboard', ClipboardController)
application.register('file-upload', FileUploadController)
application.register('playlist', PlaylistController)

// Lazy-loaded: only fetched when the controller appears on the page
application.register('player', lazyController(() => import('./player_controller')))
application.register('carousel', lazyController(() => import('./carousel_controller')))
application.register('choices', lazyController(() => import('./choices_controller')))
application.register('flatpickr', lazyController(() => import('./flatpickr_controller')))
